/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Section, Group, Copy, Title, Control, Grid, GridSet, GridItem, DateRangePickerDropDown, MultiSelectDropDown, ListTable, LineChart } from '@insticator/insticator-ui'; // iui-material
import DataLastUpdated from 'material/callout/datalastupdated/datalastupdated_container';
//utils
import {
    transpileByEmbedTableColumnHead,
    transpileByStoryTableColumnHead,
    transpileByQuestionTableBody,
    transpileByStoryTableBody,
    contentOverviewChartData,
    revenueOverviewChartData
} from 'utils/transpilers/datavisualization';
import { generateMetricsAPIString } from 'utils/fetchcontenthelpers';
import { isAfterFourPM, getDateNYC } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/analytics/overview/overview_styles';




/* ========== ~~~~~~~~~~ ANALYTICS OVERVIEW ~~~~~~~~~~ ========== */
class OverviewPage extends Component {
    constructor(props){
        super(props);
        this.state = {
            indexClicked: null
        }
    }
    componentDidMount(){
        //update detail filters with sites and date range from home page
        // this.props.updateDetailFilters(this.props.selectedSites, this.props.dateRange);
        // Fetch charts data if user permissions were received
        if(this.props.permissionsReceived){
            let contentParams = generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange});
            let revenueParams = generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange, revenueType: this.props.selectedRevenueType});
            this.handleContentAPICalls(contentParams);
            this.handleRevenueAPICalls(revenueParams);
            this.handleStoryAPICalls(contentParams);
        }
    }
    componentDidUpdate(prevProps) {
        // Fetch charts data if user permissions received after component mounts
        if(prevProps.permissionsReceived !== this.props.permissionsReceived){
            let contentParams = generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange});
            let revenueParams = generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange, revenueType: this.props.selectedRevenueType});
            this.handleContentAPICalls(contentParams);
            this.handleRevenueAPICalls(revenueParams);
            this.handleStoryAPICalls(contentParams);
        }
    }
    componentWillUnmount(){
        this.props.clearHomeControls();
    }
    handleContentAPICalls = (paramString) =>{
        if(!Object.keys(this.props.countries).length)this.props.getAllCountries(`${this.props.accountUUID}/countries?startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);
        this.props.getTotalQuestionsAnswered(paramString);
        this.props.getTotalTopQuestionsAnswered(`${paramString}${generateMetricsAPIString({count: 5})}`);
        this.props.getTotalAverageInView(paramString);
        this.props.getTotalUniqueEngagedUsers(paramString);
    };

    handleRevenueAPICalls = (paramString) => {
        if(this.props.adMetricsPermitted) this.props.getAllRevenueMetricsTotal(paramString);
    };

    handleStoryAPICalls = (paramString) => {
        this.props.getTopStories(`${paramString}${generateMetricsAPIString({count: 5})}`);
        this.props.getTopStoryClicks(paramString);
    };

    handleDynamicAPICalls = () =>{
        //this util takes in an object with all of your url param values and generates a dynamic url 😅
        let countries = this.props.selectedCountries.length >= Object.keys(this.props.countries).length ? null : this.props.selectedCountries;
        let sites = this.props.selectedSites.length >= Object.keys(this.props.sites).length ? null : this.props.selectedSites;
        let contentParams = generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange, sites, countries, devices: this.props.selectedDevices});
        let revenueParams = generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange, sites, countries, devices: this.props.selectedDevices, revenueType: this.props.selectedRevenueType});
        this.handleContentAPICalls(contentParams);
        this.handleRevenueAPICalls(revenueParams);
        this.handleStoryAPICalls(contentParams);
    };
    //methods used to format chart + table values to be displayed top left of element (currency, percentage, and standard)
    handleRevenueChartValue = (data, currency=false) => data && !!data.total ? currency ? this.formatCurrency(data.total) : this.formatNumber(data.total) : null;
    handleChartValue = data => data && !!data.total ? this.formatNumber(data.total.aggregate) : null;
    handleAverageChartValue = data => data && !!data.total ? this.formatPercentage(data.total.aggregate) : null;
    // using 'en-US' locale since we don't have any language/county setting for now
    formatCurrency = number => typeof number === 'number' ? number.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : null;
    formatNumber = number => typeof number === 'number' ? number.toLocaleString('en-US') : null;
    formatPercentage = number => typeof number === 'number' ? `${number.toLocaleString('en-US', { minimumFractionDigits: 2 })}%` : null;

    handleSiteInDropDown = () => {
        let sites = [];
        Object.keys(this.props.sites).forEach( (item) => {
            sites.push({value: item, name: this.props.sites[item]})
        });
        return sites
    };

    handleCountriesInDropDown = () => {
        let countries = [];
        Object.keys(this.props.countries).forEach( (item) => {
            countries.push({value: item, name: this.props.countries[item]})
        });
        return countries
    };

    handleDevicesInDropDown = () => {
        let devices = [];
        this.props.devices.map(item => {
            return devices.push({ value: item , name: item });
        });
        return devices;
    };

    handleVideoAdControls = type => {
        let countries = this.props.selectedCountries.length >= Object.keys(this.props.countries).length ? null : this.props.selectedCountries;
        let sites = this.props.selectedSites.length >= Object.keys(this.props.sites).length ? null : this.props.selectedSites;
        let revenueParams = generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange, sites, countries, devices: this.props.selectedDevices, revenueType: type});
        this.handleRevenueAPICalls(revenueParams);
        this.props.updateSelectedRevenueType(type);
    };
    tooltipHelper = () => this.props.selectedRevenueType ? this.props.selectedRevenueType === 'VIDEO' ? 'Video Ad' : 'Display Ad' : 'Display and Video Ad';
    linkToEmbed = (index, embedUUID) => {
        this.setState({indexClicked: index}); //this will be reset when homepage loads
        const accountUUID = this.props.isDataReceived ? false : this.props.accountUUID;
        this.props.viewAnalytics(embedUUID, accountUUID);
    };
    render() {
        return(
            <Page name={`overview`} klass={this.props.classes.overview}>
                <Group name={`filters`}>
                    <Group>
                        <MultiSelectDropDown name={this.props.selectedSites.length === 1 ? 'site' : 'sites'} title={'All Sites'} icon={`link`} button={'true'} onSelect={this.props.updateSelectedSites} buttonAction={this.handleDynamicAPICalls} items={this.handleSiteInDropDown()} selectedItems={this.props.selectedSites} disabled={!this.props.sitesReceived} />
                        <MultiSelectDropDown name={this.props.selectedDevices.length === 1 ? 'device' : 'devices'} title={'All Devices'} icon={`mobile-alt`} button={'true'} onSelect={this.props.updateSelectedDevices} buttonAction={this.handleDynamicAPICalls} items={this.handleDevicesInDropDown()} selectedItems={this.props.selectedDevices} />
                        <MultiSelectDropDown name={this.props.selectedCountries.length === 1 ? 'country' : 'countries'} title={'All Countries'} icon={`globe`} button={'true'} onSelect={this.props.updateSelectedCountries} buttonAction={this.handleDynamicAPICalls} items={this.handleCountriesInDropDown()}  selectedItems={this.props.selectedCountries} disabled={!this.props.countriesReceived} />
                    </Group>
                    <Group>
                        <DateRangePickerDropDown updateRange={this.props.updateDateRange} range={this.props.dateRange} disabledDays={[ { after: new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]} handleApply={this.handleDynamicAPICalls} use4PMLogic={true}/>
                    </Group>
                </Group>
                <div className={'dataaccuracy'}>
                    <DataLastUpdated />
                </div>
                { this.props.adMetricsPermitted ? (
                    <Section name={`admetrics`}>
                        <Copy>
                            <Title variant={'withcontrols'} >
                                <h2>Ad Metrics</h2>
                                <div className={`adcontrols`} >
                                    <Control selected={this.props.selectedRevenueType === ``} text={`All Ads`} value={``} handleSelect={this.handleVideoAdControls} />
                                    <Control selected={this.props.selectedRevenueType === `DISPLAY`} text={`Display Ads`} value={`DISPLAY`} handleSelect={this.handleVideoAdControls} />
                                    <Control selected={this.props.selectedRevenueType === `VIDEO`} text={`Video Ads`} value={`VIDEO`} handleSelect={this.handleVideoAdControls} />
                                </div>
                            </Title>
                        </Copy>
                        <Grid name={`charts`} direction={`horizontal`}>
                            <GridSet direction={`horizontal`}>
                                <GridItem>
                                    <LineChart type={`overview`}
                                               label={`Revenue`}
                                               value={this.handleRevenueChartValue(this.props.revenue, true)}
                                               tooltip={<p>This is the total {this.tooltipHelper()} revenue generated for you by Insticator</p>}
                                               data={revenueOverviewChartData(this.props.revenue)}
                                               dataType={`revenue`}
                                               loading={this.props.rmsFetching}
                                               metricType={'dollar'}
                                               yType={'dollar'}
                                               xType={'date'}
                                               moreDetails={{
                                                   type: 'action',
                                                   text: 'View Details',
                                                   color: 'supporting',
                                                   action: () => this.props.moveToPage('dashboard/analytics/detail/revenue')
                                               }} />
                                </GridItem>
                                <GridItem>
                                    <LineChart type={`overview`}
                                               label={`CPM`}
                                               value={this.handleRevenueChartValue(this.props.cpm, true)}
                                               tooltip={<p>This is the average {this.tooltipHelper()} CPM generated for you by Insticator</p>}
                                               data={revenueOverviewChartData(this.props.cpm)}
                                               dataType={`cpm`}
                                               loading={this.props.rmsFetching}
                                               metricType={'dollar'}
                                               yType={'dollar'}
                                               xType={'date'}
                                               moreDetails={{
                                                   type: 'action',
                                                   text: 'View Details',
                                                   color: 'supporting',
                                                   action: () => this.props.moveToPage('dashboard/analytics/detail/cpm')
                                               }} />
                                </GridItem>
                                <GridItem>
                                    <LineChart type={`overview`}
                                               label={`Impressions`}
                                               value={this.handleRevenueChartValue(this.props.impression)}
                                               tooltip={<p>This is the total number of {this.tooltipHelper()} Impressions generated for you by Insticator</p>}
                                               data={revenueOverviewChartData(this.props.impression)}
                                               dataType={`impression`}
                                               loading={this.props.rmsFetching}
                                               moreDetails={{
                                                   type: 'action',
                                                   text: 'View Details',
                                                   color: 'supporting',
                                                   action: () => this.props.moveToPage('dashboard/analytics/detail/impression')
                                               }} />
                                </GridItem>
                            </GridSet>
                        </Grid>
                    </Section>
                ) : null }

                <Section name={`contentperformance`}>
                    <Copy>
                        <Title>
                            <h2>Content Engagement</h2>
                        </Title>
                    </Copy>
                    <Grid name={`charts`} direction={`horizontal`}>
                        <GridSet direction={`horizontal`}>
                            <GridItem>
                                <LineChart type={`overview`}
                                           label={`Question Responses`}
                                           loading={this.props.fetchingQuestions}
                                           value={this.handleChartValue(this.props.questionsAnswered)}
                                           tooltip={<p>These are the total number of Quiz and Poll questions that have been answered for your embed(s)</p>}
                                           data={contentOverviewChartData(this.props.questionsAnswered)}
                                           dataType={`questionsanswered`}
                                           moreDetails={{
                                                    type: 'action',
                                                    text: 'View Details',
                                                    color: 'supporting',
                                                    action: () => this.props.moveToPage('dashboard/analytics/detail/questionsanswered')
                                                }} />
                            </GridItem>
                            <GridItem>
                                <ListTable
                                    name={`rank`}
                                    size={`full`}
                                    variant={'nowrap'}
                                    columnHeads={transpileByEmbedTableColumnHead(this.props.topQuestionsAnswered)}
                                    data={transpileByQuestionTableBody(this.props.topQuestionsAnswered, this.linkToEmbed, this.state.indexClicked)}
                                    dataType={`topquestionsanswered`}
                                    paginationLocation={`bottom-left`}
                                    rowsPerPage={5}
                                    clickableRow={true}
                                    loading={this.props.fetchingTopQuestion}
                                    moreDetails={{
                                            type: 'action',
                                            text: 'View Details',
                                            color: 'supporting',
                                            action: () => this.props.moveToPage('dashboard/analytics/detail/topquestionsanswered')
                                        }} />
                            </GridItem>
                        </GridSet>
                    </Grid>
                </Section>

                <Section name={`embedengagement`}>
                    <Copy>
                        <Title>
                            <h2>Embed Engagement</h2>
                        </Title>
                    </Copy>
                    <Grid name={`charts`} direction={`horizontal`}>
                        <GridSet direction={`horizontal`}>
                            <GridItem>
                                <LineChart type={`overview`} label={`Average In-View %`}
                                           loading={this.props.fetchingAverageInView}
                                           value={this.handleAverageChartValue(this.props.averageInView)}
                                           tooltip={<p>This is the number of Embed In-view events divided by total Embed load events</p>}
                                           data={contentOverviewChartData(this.props.averageInView)}
                                           dataType={`averageinview`}
                                           metricType={'percent'}
                                           yType={'percent'}
                                           xType={'date'}
                                           moreDetails={{
                                                    type: 'action',
                                                    text: 'View Details',
                                                    color: 'supporting',
                                                    action: () => this.props.moveToPage('dashboard/analytics/detail/averageinview')
                                                }} />
                            </GridItem>
                            <GridItem>
                                <LineChart type={`overview`} label={`Unique Engaged Users`}
                                           loading={this.props.fetchingUniqueEngagedUsers}
                                           value={this.handleChartValue(this.props.uniqueEngagedUsers)}
                                           tooltip={<p>This is the number of unique users who have engaged with your embed(s)</p>}
                                           data={contentOverviewChartData(this.props.uniqueEngagedUsers)}
                                           dataType={`uniqueengagedusers`}
                                           moreDetails={{
                                                    type: 'action',
                                                    text: 'View Details',
                                                    color: 'supporting',
                                                    action: () => this.props.moveToPage('dashboard/analytics/detail/uniqueengagedusers')
                                                }} />
                            </GridItem>
                        </GridSet>
                    </Grid>
                </Section>

                <Section name={`storyperformance`}>
                    <Copy>
                        <Title>
                            <h2>Story Engagement</h2>
                        </Title>
                    </Copy>
                    <Grid name={`charts`} direction={`horizontal`}>
                        <GridSet direction={`horizontal`}>
                            <GridItem>
                                <LineChart type={`overview`}
                                           label={`Story Clicks`}
                                           loading={this.props.fetchingTotalStoryClicks}
                                           value={this.handleChartValue(this.props.totalStoryClicks)}
                                           tooltip={<p>These are the total number of stories that have been clicked on your embed(s)</p>}
                                           data={contentOverviewChartData(this.props.totalStoryClicks)}
                                           dataType={`storyclicks`}
                                           moreDetails={{
                                                    type: 'action',
                                                    text: 'View Details',
                                                    color: 'supporting',
                                                    action: () => this.props.moveToPage('dashboard/analytics/detail/storyclicks')
                                                }} />
                            </GridItem>
                            <GridItem>
                                <ListTable
                                    name={`rank`}
                                    size={`full`}
                                    variant={'nowrap'}
                                    columnHeads={transpileByStoryTableColumnHead(false)}
                                    data={transpileByStoryTableBody(this.props.topStories, this.linkToEmbed, this.state.indexClicked)}
                                    dataType={`topstoryclicks`}
                                    paginationLocation={`bottom-left`}
                                    rowsPerPage={5}
                                    clickableRow={true}
                                    loading={this.props.fetchingTopStories}
                                    moreDetails />
                            </GridItem>
                        </GridSet>
                    </Grid>
                </Section>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(OverviewPage);
